import type {
  CogniteObservation,
  DefaultCDFViewMigrator,
  ObservationCDFViewMigrator,
} from '@cognite/apm-client';
import { type Observation } from '@cognite/apm-client';
import { DEFAULT_DATE_TIME_FORMAT } from '@cognite/cdf-utilities';
import type { Filters, Sort } from '@cognite/fdm-client';
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

export class ObservationIDMMigrator implements ObservationCDFViewMigrator {
  assetIDMMigrator: DefaultCDFViewMigrator;
  fileIDMMigrator: DefaultCDFViewMigrator;

  constructor(
    assetIdmMigrator: DefaultCDFViewMigrator,
    fileIDMMigrator: DefaultCDFViewMigrator
  ) {
    this.assetIDMMigrator = assetIdmMigrator;
    this.fileIDMMigrator = fileIDMMigrator;
  }

  mapDataOutward = (data: CogniteObservation): Observation => {
    return {
      externalId: data.externalId,
      sourceId: data.sourceId,
      status: data.status,

      asset: data.asset
        ? this.assetIDMMigrator.mapDataOutward(data.asset)
        : undefined,
      files: data.files?.map(this.fileIDMMigrator.mapDataOutward),
      rootLocation: data.rootLocation
        ? this.assetIDMMigrator.mapDataOutward(data.rootLocation)
        : undefined,

      description: data.description,
      troubleshooting: data.troubleshooting,
      priority: data.priority,
      type: data.type,

      createdBy: data.createdBy,
      updatedBy: data.updatedBy,

      sourceUpdatedTime: data.sourceUpdatedTime
        ? dayjs(data.sourceUpdatedTime).format(DEFAULT_DATE_TIME_FORMAT)
        : undefined,
      sourceCreatedTime: data.sourceCreatedTime
        ? dayjs(data.sourceCreatedTime).format(DEFAULT_DATE_TIME_FORMAT)
        : undefined,
    };
  };

  mapFiltersInward = (filters: Filters): Filters => {
    const newFilters = cloneDeep(filters);
    Object.keys(filters).forEach((key) => {
      if (key === 'and') {
        newFilters.and = filters.and!.map((f) => this.mapFiltersInward(f));
      }
      if (key === 'or') {
        newFilters.or = filters.or!.map((f) => this.mapFiltersInward(f));
      }
      if (key === 'not') {
        newFilters.not = this.mapFiltersInward(newFilters.not!);
      }
    });
    return newFilters;
  };

  mapSortInward = (sort: Sort): Sort => {
    return sort;
  };

  mapPropertiesInward(properties: string[]) {
    return properties;
  }

  mapDataInward = (data: Observation): CogniteObservation => {
    // Not implemented
    throw new Error('Function not implemented.');
  };
}
